import * as Sentry from '@sentry/react';

const fallbackDsn = 'https://c26fe77d22284e615ccdc5838b838278@o4509828517003264.ingest.us.sentry.io/4510882081144832';
const dsn = import.meta.env.VITE_SENTRY_DSN || fallbackDsn;

Sentry.init({
  dsn,
  enabled: Boolean(dsn),
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
  replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0),
  replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1),
  environment: import.meta.env.MODE,
});

export { Sentry };
